/* Jinja block openers.
 * Template text is emitted raw into JinjaSQL, where there is no escape that
 * keeps these inert, so a string containing one cannot be represented safely
 * in a templatized query.
 */
export const JINJA_BLOCK_OPENERS = ["{{", "{%", "{#"] as const;

/**
 * Whether `text` can be embedded in a templatized SQL query.
 */
export function isTemplateSafeText(text: string): boolean {
  return !JINJA_BLOCK_OPENERS.some((opener) => text.includes(opener));
}

/**
 * Whether `identifier` can be embedded in a templatized SQL query. Numbers
 * (positional references, e.g. `order by 2`) are always safe.
 */
export function isTemplateSafeIdentifier(identifier: string | number): boolean {
  return typeof identifier === "number" || isTemplateSafeText(identifier);
}
